module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1